import { selectDictionary } from './selectDictionary';

export const selectDealers = (state) => selectDictionary(state).dealers;
